import React from "react";

import { TEXT } from "Clients/ACCB/ACCBTheme";
import { useState } from "react";
import {
  Box,
  Link,
  Typography,
  makeStyles,
} from "@material-ui/core";
import {
  LanguageOutlined,
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({

  root: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    // fontFamily: "'Noto Serif', Georgia, serif",
  },

  /* ── Main content ── */
  content: {
    flex: 1,
    display: "flex",
    alignItems: "stretch",
    minHeight: "calc(100vh - 160px)",
  },

  /* Left 60% */
  leftPanel: {
    flex: 1,
    background:
      "linear-gradient(160deg, #61386d 0%, #3d1f45 55%, #7a3050 100%)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "48px 60px",
    position: "relative",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: { display: "none" },
  },
  bgCircle1: {
    position: "absolute",
    width: 350,
    height: 350,
    borderRadius: "50%",
    border: "1px solid rgba(255,255,255,0.08)",
    top: -80,
    left: -80,
  },
  bgCircle2: {
    position: "absolute",
    width: 250,
    height: 250,
    borderRadius: "50%",
    border: "1px solid rgba(255,255,255,0.08)",
    bottom: 40,
    right: -60,
  },
  bgCircle3: {
    position: "absolute",
    width: 500,
    height: 500,
    borderRadius: "50%",
    border: "1px solid rgba(255,255,255,0.03)",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
  },
  leftContent: { textAlign: "center", zIndex: 1, maxWidth: 480 },
  sealBox: {
    width: 120,
    height: 120,
    background: "white",
    borderRadius: "50%",
    border: "2px solid rgba(255,255,255,0.3)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 22px",
    backdropFilter: "blur(6px)",
    boxSizing: "border-box",
  },
  leftHeading: {
    color: TEXT.onDark,
    // fontFamily: "'Noto Serif', Georgia, serif",
    fontWeight: 500,
    fontSize: "clamp(22px, 2.5vw, 34px)",
    lineHeight: 1.3,
    marginBottom: 12,
  },
  leftSub: {
    color: "rgba(255,255,255,0.7)",
    // fontFamily: "'Noto Serif', Georgia, serif",
    fontSize: 15,
    lineHeight: 1.8,
    marginBottom: 32,
    // fontStyle: "italic",
  },
  dividerLine: {
    width: 60,
    height: 3,
    background: "rgba(255,255,255,0.4)",
    margin: "0 auto 28px",
    borderRadius: 2,
  },
  infoBox: {
    background: "rgba(255,255,255,0.1)",
    border: "1px solid rgba(255,255,255,0.2)",
    borderRadius: 8,
    padding: "16px 24px",
    backdropFilter: "blur(4px)",
  },
  infoItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    textAlign: "left",
    marginBottom: 10,
    "&:last-child": { marginBottom: 0 },
  },
  infoDot: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    background: "#f0c060",
    flexShrink: 0,
    marginTop: 7,
    marginRight: 7
  },
  infoText: {
    color: "rgba(255,255,255,0.8)",
    // fontFamily: "'Noto Serif', Georgia, serif",
    fontSize: 13,
    lineHeight: 1.6,
  },
  viewWebBtn: {
    marginTop: 24,
    border: "1px solid rgba(255,255,255,0.4)",
    color: TEXT.onDark,
    // fontFamily: "'Noto Serif', Georgia, serif",
    fontSize: 13,
    padding: "8px 20px",
    borderRadius: 4,
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    background: "rgba(255,255,255,0.1)",
    backdropFilter: "blur(4px)",
    "&:hover": { background: "rgba(255,255,255,0.2)" },
  },
  leftFooter: {
    position: "absolute",
    bottom: 16,
    color: "rgba(255,255,255,0.55)",
    fontSize: 12,
    // fontFamily: "'Noto Serif', Georgia, serif",
    textAlign: "center",
  },
}));

export default function Graphics() {
  const classes = useStyles();

  return (
    <>
      <Box className={classes.root}>
        {/* Main */}
        <Box className={classes.content}>
          {/* Left 60% */}
          <Box className={classes.leftPanel}>
            <Box className={classes.bgCircle1} />
            <Box className={classes.bgCircle2} />
            <Box className={classes.bgCircle3} />

            <Box className={classes.leftContent}>
              <Box className={classes.sealBox}>
                <img
                  src={"/ACCB_logo.png"}
                  alt="logo"
                  style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                />
              </Box>

              <Typography className={classes.leftHeading}>
                Arbitration & Conciliation Centre - Bengaluru
              </Typography>
              <Box className={classes.dividerLine} />
              <Typography className={classes.leftSub}>
                Official digital portal for case filing and management for the
                Arbitration & Conciliation Centre, Bengaluru. An initiative of Karnataka High Court.
              </Typography>

              <Box className={classes.infoBox}>
                {[
                  "File and track arbitration cases online",
                  "Access hearing schedules and case documents",
                  "Communicate securely with arbitrators and parties",
                  "Download orders, awards and procedural directions",
                ].map((text, i) => (
                  <Box key={i} className={classes.infoItem}>
                    <Box className={classes.infoDot} />
                    <Typography className={classes.infoText}>{text}</Typography>
                  </Box>
                ))}
              </Box>

              <Link
                href="https://arbitrationcentre.karnataka.gov.in/"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.viewWebBtn}
              >
                <LanguageOutlined style={{ fontSize: 16, marginRight: 8 }} />
                Visit Official Website
              </Link>
            </Box>

            <Typography className={classes.leftFooter}>
              © 2026 Copyrights Reserved &nbsp;|&nbsp; Powered &amp; Developed
              by Webnyay
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
}
